(function(angular){
	'use strict';
	
	angular
		.module('additionalInvestmentAgreementsModule')
		.controller('AdditionalInvestmentAgreements', [
			'CheckoutFactory',
			'globalConfig',
			AdditionalInvestmentAgreementsFunction
		]);
	
	function AdditionalInvestmentAgreementsFunction(
		CheckoutFactory,
		globalConfig
	) {
		var additionalInvestmentAgreements = this;

		additionalInvestmentAgreements.$onInit = function() {
			angular.extend(additionalInvestmentAgreements, globalConfig);

			CheckoutFactory.getDocumentsAndAgreements(additionalInvestmentAgreements.orderGroupId)
				.then(function(response) {
					angular.extend(additionalInvestmentAgreements, response);
					additionalInvestmentAgreements.formReady = true;
				})
				.catch(function() {
					additionalInvestmentAgreements.multiReitAcknowledgmentForm.$setValidity('documentLoadError', false);
				});
		};
	}
})(window.angular);